// src/hooks/blog/useGetBlogPosts.js
import { useState, useEffect } from 'react';
import { ctfClient } from '../../lib/contentful';

/**
 * Fetches all blog posts from Contentful, newest first.
 * @returns {Promise<Array<{
 *   title: string;
 *   slug: string;
 *   excerpt: string;
 *   publishDate: string;
 *   authorName: string;
 *   coverImageUrl: string | null;
 *   keywords:string[];
 * }>>}
 */
export async function getAllBlogPost() {
  const response = await ctfClient.getEntries({
    content_type: 'locumspaceBlogPosts',
    order: '-fields.publishDate',
  });

  return response.items.map((item) => {
    const { sys, fields } = item;
    return {
      id: sys.id, // ← add this
      title: fields.title,
      slug: fields.slug,
      excerpt: fields.excerpt || '',
      publishDate: fields.publishDate,
      authorName: fields.authorName || 'Unknown',
      coverImageUrl: fields.coverImage?.fields.file?.url || null,
      body: fields.body.content
        .flatMap((block) => block.content.map((node) => node.value))
        .join('\n'),
      keywords: item.keywords || [],
    };
  });
}

/**
 * React hook that wraps getAllBlogPost with loading & error state.
 * Returns { posts, loading, error, refresh }.
 */
export function useGetBlogPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAllBlogPost();
      console.log(data);
      setPosts(data);
    } catch (err) {
      console.error('useGetBlogPosts error:', err);
      setError(err.message || 'Unknown error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return { posts, loading, error, refresh };
}
